import type { LoadableType } from '@confluence/loadable';
import { LoadablePaint, MustPreloadLoadableNames } from '@confluence/loadable';

export const NativeCollabLoader: LoadableType<Omit<Omit<any, 'pageTreeStateUpdater'>, 'flags'>> =
	LoadablePaint({
		name: MustPreloadLoadableNames.NativeCollabLoader,
		loader: async () => {
			const { NativeCollabComponent } = await import(
				/* webpackChunkName: "loadable-NativeCollabComponent" */ '../src/NativeCollabComponent.tsx'
			);
			return NativeCollabComponent;
		},
	});
